/* AURAVEAN REBORN: small progressive-enhancement layer, no dependencies. */
(() => {
  'use strict';
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    const setMenu = open => {
      mobileMenu.hidden = !open;
      menuToggle.setAttribute('aria-expanded', String(open));
      menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    };
    menuToggle.addEventListener('click', () => setMenu(mobileMenu.hidden));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') setMenu(false); });
    mobileMenu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setMenu(false)));
    window.addEventListener('resize', () => { if (window.innerWidth > 1050) setMenu(false); });
  }

  const productVariant = document.querySelector('[data-product-variants]');
  const addButton = document.querySelector('[data-add-to-cart]');
  const productPrice = document.getElementById('ProductPrice');
  if (productVariant && addButton) {
    const setPrice = () => {
      const opt = productVariant.selectedOptions[0];
      if (!opt) return;
      const price = opt.dataset.price;
      const available = opt.dataset.available === 'true';
      if (productPrice) productPrice.textContent = price;
      addButton.disabled = !available;
      addButton.textContent = available ? `ADD TO BAG — ${price}` : 'SOLD OUT';
    };
    productVariant.addEventListener('change', setPrice);
  }
  const qty = document.getElementById('ProductQuantity');
  if (qty) document.querySelectorAll('[data-qty-change]').forEach(button => {
    button.addEventListener('click', () => {
      qty.value = String(Math.max(1, (parseInt(qty.value, 10) || 1) + Number(button.dataset.qtyChange)));
    });
  });
  const gallery = document.querySelector('[data-gallery-main] .main-product-image');
  if (gallery) document.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      gallery.src = thumb.dataset.imageUrl;
      gallery.srcset = '';
      gallery.alt = thumb.dataset.imageAlt || '';
      document.querySelectorAll('[data-gallery-thumb]').forEach(b => b.classList.remove('is-selected'));
      thumb.classList.add('is-selected');
    });
  });

  // Native GET collection filtering: sort and checkbox selections preserve Shopify filter params.
  const filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    filterForm.querySelectorAll('[data-sort-select],input[type=checkbox]').forEach(control => {
      control.addEventListener('change', () => filterForm.requestSubmit());
    });
    filterForm.querySelectorAll('input[type=number]').forEach(field => {
      field.addEventListener('change', () => filterForm.requestSubmit());
    });
  }
})();
